module.exports = __webpack_public_path__ + "3c580164a100ea1a4138fb8fd1c296e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Help/screenshots/Wizard Page (6).png
// module id = 1049
// module chunks = 0